<template>
  <div class="relative-article">
    <el-row>
      <el-col :span="6">
        <span>{{ title }}名称：</span>
        <el-input v-model="name" style="width: 150px" placeholder="请输入文章名称" clearable></el-input>
      </el-col>
      <el-col :span="8" :offset="1">
        <span>{{ title }}分类：</span>
        <el-cascader v-model="categoryId" placeholder="请选择" :options="courseCategory"
          :props="{ expandTrigger: 'hover', emitPath: false, checkStrictly: true }" clearable></el-cascader>
      </el-col>
      <el-col :span="6" :offset="3">
        <div class="box box-align-center box-pack-end mt-btns">
          <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          <el-button plain icon="el-icon-refresh" @click="search('refresh')">重置</el-button>
        </div>
      </el-col>
    </el-row>
    <div class="mt12 conmmon-table">
      <dy-table :columns="_columns" :table-data="tableData" ref="table" v-loading="tableLoading" :total="total"
        :page-num="pageNum" :page-size="10" @current-change="onPageChange" @selection-change="onSelectionChange"
        element-loading-text="加载中" rowKeyName="recommendId"></dy-table>
      <div class="box box-align-center box-pack-end mt-btns" style="margin-top: 12px">
        <el-button type="primary" plain @click="saveData">保存</el-button>
        <el-button type="danger" plain @click="closeDialog">取消</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import DyTable from '@/components/common/dytable';
import { getList4Pop, getCourseList, getAllClassification, getLiveList, getLiveCategory } from '@/api/index';
import { encrypt, decrypt } from '@/api/common_encrypt';
import { formatDate } from '@/utils/utils';

export default {
  name: 'articleCommon',
  components: {
    DyTable,
  },
  props: {
    type: {
      type: Number,
      default: 1,
    },
    title: {
      type: String,
      default: '',
    },
    columns: {
      type: Array,
      default: () => [],
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    // 使用 computed 计算每行的索引
    indexMethod() {
      return (index) => {
        return (this.pageNum - 1) * this.pageSize + index + 1;
      };
    },
  },
  watch: {
    list(newVal, oldVal) {
      this.setSelect();
    },
  },
  data() {
    return {
      name: '',
      categoryId: '',
      tableLoading: true,
      pageNum: 1,
      pageSize: 10,
      options: [],
      _columns: [],
      tableData: [],
      total: 0,

      chooseVisible: false,
      arTableLoading: true,
      arTotal: 0,
      courseCategory: [],

      selectId: [],
      selection: [],

      searchForm: {},

      pageChange: false,
      isSetSelect: false,
    };
  },
  created() {
    this._columns = [
      {
        type: 'selection',
        width: '55',
      },
      ...this.columns,
    ];
  },
  mounted() {
    this.selectId = this.list.map((e) => {
      return e.recommendId;
    });

    this.selection = this.list;

    this.getList();
    this.getCategory();
  },
  methods: {
    // 关闭弹窗
    closeDialog() {
      this.$emit('close-dialog');
    },

    listFor(arr) {
      let childrenStr = '';
      if (this.type == 1) {
        childrenStr = 'childCourseCategory';
      } else if (this.type == 2) {
        childrenStr = 'childClass';
      }
      let children = [];
      if (arr != null && arr != '' && arr != undefined) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i][childrenStr] != '' && arr[i][childrenStr] != null && arr[i][childrenStr] != undefined) {
            children.push({
              value: arr[i].id,
              label: arr[i].name,
              children: this.listFor(arr[i][childrenStr]),
            });
          } else {
            children.push({
              value: arr[i].id,
              label: arr[i].name,
              children: this.listFor(arr[i][childrenStr]),
            });
          }
        }
      } else {
        return;
      }
      return children;
    },
    async getCategory() {
      if (this.type == 1) {
        this.courseCategory = await this.$store.dispatch('category/getCourseCategory');

      } else if (this.type == 2) {
        getAllClassification().then((res) => {
          if (res.result == 1) {
            var ress = JSON.parse(decrypt(res.data));
            this.sortList = this.listFor(ress);
          } else {
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'error',
            });
          }
        });
      } else if (this.type == 3) {
        getLiveCategory().then((res) => {
          if (res.result == 1) {
            var ress = JSON.parse(decrypt(res.data));
            console.log('获取所有直播分类', ress);
            this.sortList = this.listFor(ress);
          } else {
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'error',
            });
          }
        });
      }
    },

    search(msg) {
      this.pageNum = 1;

      this.searchForm = {
        categoryId: this.categoryId,
        classification: this.categoryId,

        courseTitle: this.name,
        title: this.name,
        liveName: this.name,
        // liveName: this.name,
      };
      if (msg == 'refresh') {
        this.name = '';
        this.categoryId = '';
        this.searchForm = {};
      }

      this.getList();
    },

    onPageChange(val) {
      this.pageNum = val;
      this.getList();
    },

    //获取文章列表
    getList() {
      this.tableLoading = true;
      if (this.type == 1) {
        let info = {
          needPage: true,
          page: this.pageNum,
          pageSize: this.pageSize,
          publishStatus: 1,

          ...this.searchForm,
        };
        var data = encrypt(JSON.stringify(info));
        getCourseList(data).then((res) => {
          if (res.result == 1) {
            var ress = JSON.parse(decrypt(res.data));
            console.log('ress :>> ', ress);
            this.tableLoading = false;
            this.total = ress.total;
            this.tableData = ress.list;

            for (let e of this.tableData) {
              e.recommendId = e.id;
              e.recommendType = this.type;
              e.recommendName = e.courseTitle;
              e.recommendCategory = e.categoryName;
              e.recommendUser = e.bgUserName;
              e.recommendTime = formatDate(new Date(e.updateDateline * 1000), 'yyyy-MM-dd hh:mm:ss');
              delete e['id'];
            }

            if (this.isSetSelect) {
              this.pageChange = true;
            }
            this.$nextTick(() => {
              this.setSelect();
            });
          } else {
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'error',
            });
          }
        });
      } else if (this.type == 2) {
        let info = {
          page: this.pageNum,
          pageSize: this.pageSize,

          ...this.searchForm,
        };
        var data = encrypt(JSON.stringify(info));
        getList4Pop(data).then((res) => {
          if (res.result == 1) {
            var ress = JSON.parse(decrypt(res.data));
            this.tableLoading = false;
            this.total = ress.total;
            this.tableData = ress.list;

            for (let e of this.tableData) {
              e.recommendId = e.id;
              e.recommendType = this.type;
              e.recommendName = e.title;
              e.recommendCategory = e.classificationName;
              e.recommendUser = e.author;
              e.recommendTime = formatDate(new Date(e.publishtime), 'yyyy-MM-dd hh:mm:ss');

              delete e['id'];
            }
            if (this.isSetSelect) {
              this.pageChange = true;
            }
            this.$nextTick(() => {
              this.setSelect();
            });
          } else {
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'error',
            });
          }
        });
      } else if (this.type == 3) {
        this.tableLoading = true;
        let info = {
          // id: '',
          page: this.pageNum,
          pageSize: this.pageSize,

          ...this.searchForm,
        };
        console.log(info);
        var data = encrypt(JSON.stringify(info));
        getLiveList(data).then((res) => {
          if (res.result == 1) {
            var ress = JSON.parse(decrypt(res.data));
            console.log('live :>> ', ress);
            this.tableLoading = false;
            this.total = ress.total;
            this.tableData = ress.list;

            for (let e of this.tableData) {
              e.recommendId = e.id;
              e.recommendType = this.type;
              e.recommendName = e.liveName;
              e.recommendCategory = e.categoryName;
              e.recommendUser = e.userNickName;
              e.recommendTime = e.updateTime;
              delete e['id'];
            }
            if (this.isSetSelect) {
              this.pageChange = true;
            }
            this.$nextTick(() => {
              this.setSelect();
            });
          } else {
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'error',
            });
          }
        });
      }
    },

    setSelect() {
      this.$refs.table.$refs.ElTable.clearSelection();
      let sel = this.tableData.filter((item) => this.selectId.includes(item.recommendId));
      this.$nextTick(() => {
        sel.forEach((e) => {
          this.$refs.table.$refs.ElTable.toggleRowSelection(e, true);
        });
      });
    },


    onSelectionChange(val) {
      if (this.pageChange) {
        this.pageChange = false;
        return;
      }
      let pageId = this.tableData.map((e) => {
        return e.recommendId;
      });
      let selId = val.map((e) => {
        return e.recommendId;
      });

      let delId = pageId.filter((recommendId) => !selId.includes(recommendId));



      this.selectId = [...new Set([...this.selectId, ...pageId].filter((id) => !delId.includes(id)))];
      this.selection = [...this.selection, ...val];
      this.selection = Array.from(new Map(this.selection.map((item) => [item.recommendId, item])).values());
      this.selection = this.selection.filter((e) => !delId.includes(e.recommendId));
      this.isSetSelect = true;
    },

    saveData() {
      this.$emit('saveData', this.selection);
      this.$emit('close-dialog');
    },
  },
};
</script>
<style scoped>
.ra-table {
  margin-top: 12px;
  margin-bottom: 22px;
}
</style>
